import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LoginForm from './LoginForm';
import MobileMenu from './MobileMenu';
import NiceSelect from './NiceSelect';
import { navActive, PAGES_PATHS, ACTIVITY_PATHS } from './navActive';

function HeaderFour() {
   const { pathname } = useLocation();
   const languageOptions = [
      { value: "language", label: "Language" },
      { value: "CNY", label: "CNY" },
      { value: "EUR", label: "EUR" },
      { value: "AUD", label: "AUD" },
   ];
   const [isSticky, setIsSticky] = useState(false);
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
   const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);

   useEffect(() => {
      const handleScroll = () => {
         if (window.scrollY > 500) {
            setIsSticky(true);
         } else {
            setIsSticky(false);
         }
      };

      window.addEventListener("scroll", handleScroll);
      return () => {
         window.removeEventListener("scroll", handleScroll);
      };
   }, []);
   return (
      <>
         <header className="th-header header-layout1 header-layout4">
            {/* TODO: re-enable header top bar (address, hours, FAQ, Support, Sign In) later
            <div className="header-top">
               <div className="container th-container">
                  <div className="row justify-content-center justify-content-xl-between align-items-center">
                     <div className="col-auto d-none d-md-block">
                        <div className="header-links">
                           <ul>
                              <li className="d-none d-xl-inline-block">
                                 <i className="fa-sharp fa-regular  fa-location-dot" />
                                 <span>45 New Eskaton Road, Austria</span>
                              </li>
                              <li className="d-none d-xl-inline-block">
                                 <i className="fa-regular fa-clock" />
                                 <span>Sun to Friday: 8.00 am - 7.00 pm</span>
                              </li>
                           </ul>
                        </div>
                     </div>
                     <div className="col-auto">
                        <div className="header-right">
                           <div className="currency-menu">
                              <NiceSelect options={languageOptions} defaultValue="Language" />
                           </div>
                           <div className="header-links">
                              <ul>
                                 <li className="d-none d-md-inline-block">
                                    <Link to="/faq">FAQ</Link>
                                 </li>
                                 <li className="d-none d-md-inline-block">
                                    <Link to="/contact">Support</Link>
                                 </li>
                                 <li>
                                    <button
                                       type="button"
                                       onClick={() => setIsLoginFormOpen(true)}
                                    >
                                       Sign In / Register
                                       <i className="fa-regular fa-user" />
                                    </button>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            */}
            <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
               {/* Main Menu Area */}
               <div className="menu-area">
                  <div className="container th-container">
                     <div className="row align-items-center justify-content-between">
                        <div className="col-auto">
                           <div className="header-logo">
                              <Link to="/">
                                 <img src="/assets/img/twa-logo.png" alt="Travel With Ammar — Travel Wander Explore" />
                              </Link>
                           </div>
                        </div>
                        <div className="col-auto">
                           <nav className="main-menu d-none d-xl-inline-block">
                              <ul>
                                 {/* Home → Home Travel only */}
                                            <li>
                                                <Link className={navActive(pathname, '/', { exact: true })} to="/">
                                                    Home
                                                </Link>
                                                {/* TODO: re-enable Home mega menu demos later
                                                <ul className="mega-menu mega-menu-content">
                                       <li>
                                          <div className="container">
                                             <div className="row gy-4">
                                                <div className="col-lg-3">
                                                   <div className="mega-menu-box">
                                                      <div className="mega-menu-img">
                                                         <img
                                                            src="/assets/img/pages/home-travel.jpg"
                                                            alt="Home One"
                                                         />
                                                         <div className="btn-wrap">
                                                            <Link

                                                               to="/"
                                                               className="th-btn"
                                                            >
                                                               View Demo
                                                            </Link>
                                                         </div>
                                                      </div>
                                                      <h3 className="mega-menu-title">
                                                         <Link to="/">
                                                            <span>01.</span>Home Travel
                                                         </Link>
                                                      </h3>
                                                   </div>
                                                </div>
                                                <div className="col-lg-3">
                                                   <div className="mega-menu-box">
                                                      <div className="mega-menu-img">
                                                         <img
                                                            src="/assets/img/pages/home-tour.jpg"
                                                            alt="Home Two"
                                                         />
                                                         <div className="btn-wrap">
                                                            <Link

                                                               to="/home-tour"
                                                               className="th-btn "
                                                            >
                                                               View Demo
                                                            </Link>
                                                         </div>
                                                      </div>
                                                      <h3 className="mega-menu-title">
                                                         <Link to="/home-tour">
                                                            <span>02.</span>Home Tour
                                                         </Link>
                                                      </h3>
                                                   </div>
                                                </div>
                                                <div className="col-lg-3">
                                                   <div className="mega-menu-box">
                                                      <div className="mega-menu-img">
                                                         <img
                                                            src="/assets/img/pages/home-agency.jpg"
                                                            alt="Home Three"
                                                         />
                                                         <div className="btn-wrap">
                                                            <Link

                                                               to="/home-agency"
                                                               className="th-btn "
                                                            >
                                                               View Demo
                                                            </Link>
                                                         </div>
                                                      </div>
                                                      <h3 className="mega-menu-title">
                                                         <Link to="/home-agency">
                                                            <span>03.</span>Home Agency
                                                         </Link>
                                                      </h3>
                                                   </div>
                                                </div>
                                                <div className="col-lg-3">
                                                   <div className="mega-menu-box">
                                                      <div className="mega-menu-img">
                                                         <img
                                                            src="/assets/img/pages/home-yacht.jpg"
                                                            alt="Home Four"
                                                         />
                                                         <div className="btn-wrap">
                                                            <Link

                                                               to="/home-yacht"
                                                               className="th-btn "
                                                            >
                                                               View Demo
                                                            </Link>
                                                         </div>
                                                      </div>
                                                      <h3 className="mega-menu-title">
                                                         <Link to="/home-yacht">
                                                            <span>04.</span>Home Yacht
                                                         </Link>
                                                      </h3>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </li>
                                    </ul>
                                                */}
                                            </li>
                                 <li>
                                    <Link className={navActive(pathname, '/about', { exact: true })} to="/about">About Us</Link>
                                 </li>
                                 <li>
                                    <Link className={navActive(pathname, '/destination')} to="/destination">Destinations</Link>
                                 </li>
                                 <li>
                                    <Link className={navActive(pathname, '/service')} to="/service">Services</Link>
                                 </li>
                                 <li>
                                    <Link className={navActive(pathname, ACTIVITY_PATHS)} to="/activities">Activities</Link>
                                 </li>
                                    <li className="menu-item-has-children">
                                    <Link className={navActive(pathname, PAGES_PATHS)} to="/tour">Tours</Link>
                                    <ul className="sub-menu">
                                        <li>
                                          <Link className={navActive(pathname, '/gallery', { exact: true })} to="/gallery">Gallery</Link>
                                        </li>
                                        <li>
                                          <Link className={navActive(pathname, '/faq', { exact: true })} to="/faq">FAQ</Link>
                                        </li>
                                    </ul>
                                </li>
                                 <li>
                                    <Link className={navActive(pathname, '/blog')} to="/blog">Blog</Link>
                                 </li>
                                 <li>
                                    <Link className={navActive(pathname, '/contact', { exact: true })} to="/contact">Contact us</Link>
                                 </li>
                              </ul>
                           </nav>
                           <button
                              type="button"
                              className="th-menu-toggle d-block d-xl-none"
                              onClick={() => setIsMobileMenuOpen(true)}
                           >
                              <i className="far fa-bars" />
                           </button>
                        </div>
                        <div className="col-auto d-none d-xl-block">
                           <div className="header-button">
                              <Link to="/contact" className="th-btn style1 th-icon">
                                 Book Now
                              </Link>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="logo-bg bg-mask"
                     style={{
                        WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                        maskImage: "url(/assets/img/logo_bg_mask.png)"
                     }} />
                  <div
                     className="menu-right-bg "
                     style={{
                        WebkitMaskImage: "url(/assets/img/menu_bg_mask.png)",
                        maskImage: "url(/assets/img/menu_bg_mask.png)",
                        WebkitMaskSize: '100% 100%',
            maskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat'
                     }}
                  />
               </div>
            </div>
         </header>
         <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
         <LoginForm isOpen={isLoginFormOpen} onClose={() => setIsLoginFormOpen(false)} />
      </>
   )
}

export default HeaderFour
